/** Import business module permissions — single source of truth */

export const IMPORT_BUSINESS_PERMISSIONS = {
  LIST_ALL: 'import-business-list-all',
  LIST: 'import-business-list',
  CREATE: 'import-business-create',
  VIEW: 'import-business-view',
  EDIT: 'import-business-edit',
  DELETE: 'import-business-delete',
  RESTORE: 'import-business-restore',
  PERMANENT_DELETE: 'import-business-permanent-delete',
  STATUS: 'import-business-status',
  ASSIGN: 'import-business-assign',
};

/** Route / sidebar: any of these grants access to the listing page */
export const IMPORT_BUSINESS_LIST_ACCESS = [
  IMPORT_BUSINESS_PERMISSIONS.LIST_ALL,
  IMPORT_BUSINESS_PERMISSIONS.LIST,
  IMPORT_BUSINESS_PERMISSIONS.VIEW,
  IMPORT_BUSINESS_PERMISSIONS.EDIT,
  IMPORT_BUSINESS_PERMISSIONS.CREATE,
  IMPORT_BUSINESS_PERMISSIONS.DELETE,
  IMPORT_BUSINESS_PERMISSIONS.RESTORE,
  IMPORT_BUSINESS_PERMISSIONS.PERMANENT_DELETE,
  IMPORT_BUSINESS_PERMISSIONS.STATUS,
  IMPORT_BUSINESS_PERMISSIONS.ASSIGN,
];

/** Detail page: view or elevated list/edit access */
export const IMPORT_BUSINESS_VIEW_ACCESS = [
  IMPORT_BUSINESS_PERMISSIONS.VIEW,
  IMPORT_BUSINESS_PERMISSIONS.LIST_ALL,
  IMPORT_BUSINESS_PERMISSIONS.LIST,
  IMPORT_BUSINESS_PERMISSIONS.EDIT,
];
